<script setup>
import { computed } from 'vue';
import { bsTooltip } from 'JIX/vue-bs-tooltip.js';

const vBsTooltip = bsTooltip;

const props = defineProps({
    languages: {
        type: Array,
        required: true,
    },
    levels: {
        type: Array,
        required: true,
    },
});

const languagesSorted = computed(() => {
    const langs = props.languages.slice(0);
    const locale = document.documentElement.lang;
    langs.sort((a, b) => (b.level - a.level) || a.name.localeCompare(b.name, locale));
    return langs;
});

function getLevelName(level) {
    return props.levels.find(l => l[1] === level)?.[0] ?? "";
}

</script>

<template>
    <div class="cv-print-languageskills">
        <div class="row" v-for="lang in languagesSorted" :key="lang.code">
            <div class="col-7 cv-print-languageskills__name">
                {{ lang.name }}
            </div>
            <div class=" col-5 cv-print-languageskills__level">
                <span
                    v-bs-tooltip="{ trigger: 'hover', placement: 'right', offset: '0, 10' }"
                    :title="lang.level > 0 ? getLevelName(lang.level) : undefined"
                >
                    <span class="sr-only" v-if="lang.level > 0">{{ getLevelName(lang.level) }}</span>
                    <span :class="{ 'cv-print-languageskills__dot': lang.level >= i, 'cv-print-languageskills__dot-empty': lang.level < i }" v-for="i in 4" :key="i" />
                </span>
            </div>
        </div>
    </div>
</template>
